// ----------------------
// AUTH
// ----------------------
export const LOADING = 'LOADING';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RESET_PASSWORD = 'RESET_PASSWORD';

// ----------------------
// ENTITIES
// ----------------------
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export const RECEIVE_ENTITIES = 'RECEIVE_ENTITIES';
export const RECEIVE_ENTITY = 'RECEIVE_ENTITY';

// ----------------------
// REGISTRATION
// ----------------------
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';
export const UPDATE_NESTED_PROPERTY = 'UPDATE_NESTED_PROPERTY';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js